import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { fetchAccountBillabilityAction } from "../slices/accountBillabilitySlice";

export function useAccountBillability(accountingIds: string[]) {
  const dispatch = useDispatch();
  const { billability, loading, error } = useSelector(
    (state: RootState) => state.accountBillability,
  );

  useEffect(() => {
    const unresolved = accountingIds.filter(
      (id) => id && billability[id] === undefined,
    );
    if (unresolved.length > 0) {
      dispatch(fetchAccountBillabilityAction(unresolved));
    }
  }, [accountingIds, billability, dispatch]);

  const isBillable = useCallback(
    (accountingId: string): boolean | undefined => {
      const status = billability[accountingId];
      if (status === undefined) return undefined;
      return status === "billable";
    },
    [billability],
  );

  const getBillabilityMessage = useCallback(
    (accountingId: string): string => {
      if (billability[accountingId] === "no_account") {
        return `Account ${accountingId} does not exist in CARA.`;
      }
      return `Account ${accountingId} has no payment method on file for Stochastic invoices.`;
    },
    [billability],
  );

  return { isBillable, getBillabilityMessage, loading, error };
}
